module.exports = __webpack_public_path__ + "static/2007-globe-bkg-faaee21f372a06aed1117d6faa17975e.jpg";